<div class="row">
  <div class="col-12">
    <div
      class="page-title-box d-flex flex-wrap align-items-start justify-content-between gap-2"
      >
      <div>
        <h4 class="page-title mb-1">
          {{ "campaign.campaignForm.pageTitle" | translate }}
        </h4>
      </div>
      <!-- `mb-2` only shows once the chips wrap under the title, which two
      chips always do on a phone (RCS + WhatsApp do not fit beside it).
      Nothing else sits between them and the step card on this screen, so
      without it the lower chip touches the card. Beside the title it
      changes nothing: the title stays the taller item of that line. -->
      <div class="d-flex flex-wrap align-items-center gap-2 mt-3 mb-2">
        <campaign-wallet />
      </div>
    </div>
  </div>
</div>
<form [formGroup]="formGroup">
  <div class="tab-content b-0 mb-0">
    <div
      class="tab-pane"
      id="channel"
      role="tabpanel"
      [class.active]="stepIndex() === 0"
      [class.show]="stepIndex() === 0"
      >
      <div class="row">
        <div class="col-12 col-xl-8">
          <div class="card campaign-step-card">
            <div class="card-body">
              <ng-container [ngTemplateOutlet]="stepperNav" />
              <div class="campaign-step-scroll">
                <div class="mb-3">
                  <h4 class="header-title mb-1">
                    {{
                    "campaign.campaignForm.chooseSendingChannel" | translate
                    }}
                  </h4>
                  <p class="text-muted mb-0">
                    {{
                    "campaign.campaignForm.chooseSendingChannelSubtitle"
                    | translate
                    }}
                  </p>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="campaignName">
                    {{ "campaign.campaignForm.campaignName" | translate }}
                    <span class="text-danger">*</span>
                  </label>
                  <input
                    id="campaignName"
                    class="form-control"
                    maxlength="50"
                    formControlName="name"
                    [placeholder]="
                      'campaign.campaignForm.campaignNamePlaceholder'
                        | translate
                    "
                    />
                  <field-error-component
                    [field]="'name'"
                    [label]="'campaign.campaignForm.campaignName' | translate"
                    [formGroup]="formGroup"
                    />
                </div>

                <label class="form-label">
                  {{ "campaign.campaignForm.selectChannel" | translate }}
                  <span class="text-danger">*</span>
                </label>
                @if (allChannel.length > 6) {
                  <div class="input-trend-search mb-2">
                    <input
                      type="search"
                      class="form-control"
                      [formControl]="filterControlChannel"
                      [placeholder]="
                        'campaign.campaignForm.searchChannelPlaceholder'
                          | translate
                      "
                      [attr.aria-label]="
                        'campaign.campaignForm.searchChannelPlaceholder'
                          | translate
                      "
                      />
                    <span class="mdi mdi-magnify search-icon"></span>
                  </div>
                }

                <div
                  class="campaign-picks"
                  role="radiogroup"
                  [attr.aria-label]="
                    'campaign.campaignForm.selectChannel' | translate
                  "
                  >
                  @for (channel of channels; track channel._id) {
                    <div
                      class="campaign-pick is-collapsible"
                      [class.is-selected]="isChannelSelected(channel)"
                      [class.is-unavailable]="!isChannelSelectable(channel)"
                      >
                      <div class="campaign-pick-head">
                        <button
                          type="button"
                          class="campaign-pick-select"
                          role="radio"
                          [attr.aria-checked]="isChannelSelected(channel)"
                          [disabled]="!isChannelSelectable(channel)"
                          (click)="selectChannelCard(channel)"
                          >
                          <span
                            class="campaign-pick-radio"
                            aria-hidden="true"
                          ></span>
                          <span class="campaign-pick-body">
                            <b>{{ channel.name }}</b>
                            <span>{{
                              channelTypeKey(channel) | translate
                            }}</span>
                          </span>
                        </button>
                        <span
                          class="campaign-badge"
                          [ngClass]="channelBadgeClass(channel)"
                          >
                          {{ channelBadgeKey(channel) | translate }}
                        </span>
                        <button
                          type="button"
                          class="campaign-pick-toggle"
                          [class.is-open]="isChannelExpanded(channel)"
                          [attr.aria-expanded]="isChannelExpanded(channel)"
                          [attr.aria-label]="
                            'campaign.campaignForm.channelDetailToggle'
                              | translate
                          "
                          (click)="toggleChannelDetail(channel)"
                          >
                          <i
                            class="mdi mdi-chevron-down campaign-collapse-caret"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>

                      @if (isChannelExpanded(channel)) {
                        <div class="campaign-pick-detail">
                          <dl class="campaign-pick-facts">
                            <dt>
                              {{
                              "campaign.campaignForm.channelDetailIdentifier"
                              | translate
                              }}
                            </dt>
                            <dd>
                              @if (channel.identifier) {
                                {{ channel.identifier }}
                              } @else {
                                {{
                                "campaign.campaignForm.channelDetailNoIdentifier"
                                | translate
                                }}
                              }
                            </dd>

                            <dt>
                              {{
                              "campaign.campaignForm.channelDetailState"
                              | translate
                              }}
                            </dt>
                            <dd>{{ channelStateKey(channel) | translate }}</dd>

                            @if (channelQualityKey(channel); as qualityKey) {
                              <dt>
                                {{
                                "campaign.campaignForm.channelDetailQuality"
                                | translate
                                }}
                              </dt>
                              <dd>{{ qualityKey | translate }}</dd>
                            }
                          </dl>

                          @if (channel.campaignOnly) {
                            <div class="campaign-note is-warn mt-3">
                              <i
                                class="mdi mdi-alert-outline"
                                aria-hidden="true"
                              ></i>
                              <span>{{
                                "campaign.campaignForm.channelDetailCampaignOnly"
                                | translate
                              }}</span>
                            </div>
                          }

                          @if (isChannelRcs(channel)) {
                            <div class="campaign-pick-behavior mt-3">
                              <b class="campaign-pick-behavior-title">
                                {{
                                "campaign.campaignForm.rcsAgentGroupLabel"
                                | translate
                                }}
                              </b>
                              <span class="campaign-field-hint mt-0">
                                {{
                                "campaign.campaignForm.rcsAgentGroupHint"
                                | translate
                                }}
                              </span>

                              <div
                                class="campaign-pick is-block is-static mt-2"
                                >
                                <span class="campaign-pick-body">
                                  <b class="campaign-pick-title">
                                    <span>
                                      {{
                                      (isRcsChannelConversational(channel)
                                      ? "campaign.campaignForm.rcsAgentConversational"
                                      : "campaign.campaignForm.rcsAgentNonConversational"
                                      ) | translate
                                      }}
                                      <span
                                        class="campaign-chip"
                                        [class.is-brand]="
                                          isRcsChannelConversational(channel)
                                        "
                                        >
                                        {{
                                        (isRcsChannelConversational(channel)
                                        ? "campaign.campaignForm.rcsAgentPillConversational"
                                        : "campaign.campaignForm.rcsAgentPillNonConversational"
                                        ) | translate
                                        }}
                                      </span>
                                    </span>
                                    <span class="campaign-pick-meta">
                                      {{ channel.name }}
                                      <span class="sep" aria-hidden="true"
                                        >·</span
                                        >
                                        {{
                                        (isRcsChannelConversational(channel)
                                        ? "campaign.campaignForm.rcsAgentKindConversational"
                                        : "campaign.campaignForm.rcsAgentKindSingle"
                                        ) | translate
                                        }}
                                      </span>
                                    </b>
                                    <span
                                    [innerHTML]="
                                      (isRcsChannelConversational(channel)
                                        ? 'campaign.campaignForm.rcsAgentConversationalBody'
                                        : 'campaign.campaignForm.rcsAgentNonConversationalBody'
                                      ) | translate
                                    "
                                    ></span>
                                    <span
                                      class="campaign-pick-rule"
                                      aria-hidden="true"
                                    ></span>
                                    <span class="campaign-pick-bullet">
                                      <span
                                        class="campaign-badge-dot"
                                        aria-hidden="true"
                                      ></span>
                                      <span
                                      [innerHTML]="
                                        (isRcsChannelConversational(channel)
                                          ? 'campaign.campaignForm.rcsAgentConversationalRule'
                                          : 'campaign.campaignForm.rcsAgentNonConversationalRule'
                                        ) | translate
                                      "
                                      ></span>
                                    </span>
                                  </span>
                                </div>

                                <div class="campaign-note is-brand mt-3">
                                  <span
                                    class="campaign-badge-dot mt-2"
                                    aria-hidden="true"
                                  ></span>
                                  <span
                                  [innerHTML]="
                                    (isRcsChannelConversational(channel)
                                      ? 'campaign.campaignForm.rcsAgentCalloutConversational'
                                      : 'campaign.campaignForm.rcsAgentCalloutSingle'
                                    ) | translate
                                  "
                                  ></span>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      } @empty {
                      @if (channels) {
                        <div class="campaign-note is-warn">
                          <i class="mdi mdi-alert-outline" aria-hidden="true"></i>
                          <span>{{
                            "campaign.campaignForm.noChannelsFound" | translate
                          }}</span>
                        </div>
                      }
                    }
                  </div>
                  <field-error-component
                    [field]="'channel'"
                    [label]="'campaign.campaignForm.channelLabel' | translate"
                    [formGroup]="formGroup"
                    />

                  @if (disconnectedChannels.length > 0) {
                    <div class="campaign-note is-warn mt-3">
                      <i class="mdi mdi-alert-outline" aria-hidden="true"></i>
                      <span>
                        <b>{{
                          "campaign.campaignForm.channelDisconnectedTitle"
                          | translate: { names: disconnectedChannelNames }
                        }}</b>
                        {{
                        "campaign.campaignForm.channelDisconnectedHint"
                        | translate
                        }}
                      </span>
                    </div>
                  }
                </div>
                <div class="campaign-form-actions">
                  <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="disableNextChannel()"
                    (click)="nextStep()"
                    >
                    {{ "campaign.campaignForm.next" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4">
            <div class="campaign-rail">
              <ng-container [ngTemplateOutlet]="summaryRail" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="tab-pane"
        id="messages"
        role="tabpanel"
        [class.active]="stepIndex() === 1"
        [class.show]="stepIndex() === 1"
        >
        <div class="row">
          <div class="col-12 col-xl-8">
            <div class="card campaign-step-card">
              <div class="card-body">
                <ng-container [ngTemplateOutlet]="stepperNav" />
                <div class="campaign-step-scroll">
                  <div class="mb-3">
                    <h4 class="header-title mb-1">
                      {{ "campaign.campaignForm.configureMessage" | translate }}
                    </h4>
                  </div>
                  @if (isSelectedChannelCloudAPI()) {
                    <div class="row" formGroupName="cloudAPIDataGroup">
                      <div class="col-xs-12 col-xl-12 mb-3">
                        <wa-template-select
                          [channel]="selectedChannel"
                          [selectedTemplateId]="$safeNavigationMigration(selectedTemplate?.id)"
                          (onSelectTemplate)="onSelectTemplate($event)"
                        ></wa-template-select>
                      </div>
                      <div class="col-xs-12 col-xl-12 mb-3">
                        <div class="mb-3">
                          <h4 class="header-title mb-1">
                            {{
                            "campaign.campaignForm.editVariables" | translate
                            }}
                          </h4>
                          <p class="text-muted mb-0">
                            {{
                            "campaign.campaignForm.editVariablesSubtitle"
                            | translate
                            }}
                          </p>
                        </div>

                        @if (selectedTemplate) {
                          <div class="campaign-panel">
                            @if (headerParams.controls.length > 0) {
                              <div class="mb-3">
                                <span class="campaign-group-label">
                                  {{
                                  "campaign.campaignForm.headerVariables"
                                  | translate
                                  }}
                                </span>
                                <div formArrayName="headerParams">
                                  @if (!isMedia) {
                                    @for (
                                      header of headerParams.controls;
                                      track header;
                                      let i = $index
                                      ) {
                                      <div
                                        [formGroupName]="i"
                                        class="col-12 mb-2"
                                        >
                                        <label class="form-label"
                                          >{{
                                          "campaign.campaignForm.headerVariableN"
                                          | translate: { n: i + 1 }
                                          }}
                                          <span class="text-danger"
                                            >*</span
                                            ></label
                                            >
                                            <input
                                              class="form-control"
                                              matInput
                                              formControlName="value"
                                        [placeholder]="
                                          'campaign.campaignForm.fillHeaderVariable'
                                            | translate
                                        "
                                              [matAutocomplete]="autoHeader"
                                        (input)="
                                          onInputChange('headers', i + 1)
                                        "
                                        (focus)="
                                          onInputChange('headers', i + 1)
                                        "
                                              />
                                            <mat-autocomplete
                                              #autoHeader="matAutocomplete"
                                        (optionSelected)="
                                          onOptionSelected(
                                            'headers',
                                            $event.option.viewValue,
                                            i + 1
                                          )
                                        "
                                              >
                                              @for (
                                                option of filteredOptions;
                                                track option
                                                ) {
                                                <mat-option [value]="option.text">{{
                                                  option.text
                                                }}</mat-option>
                                              }
                                            </mat-autocomplete>
                                          </div>
                                        }
                                      } @else if (
                                        headerComponent.format === "IMAGE"
                                        ) {
                                        <div class="col-lg-12 mb-3">
                                          <div class="upload-area">
                                            @if (loadingSpinner$ | async) {
                                              <loading-component
                                                class="loading"
                                                diameter="20"
                                                />
                                            } @else if (
                                              !headerParams?.value[0]?.value
                                              ) {
                                              <div
                                                class="placeholder-content"
                                                (click)="addCloudAPIFile()"
                                                >
                                                <i
                                                  class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                                                ></i>
                                                <p class="text-primary">
                                                  {{
                                                  "campaign.campaignForm.clickToUpload"
                                                  | translate
                                                  }}
                                                </p>
                                                <p class="text-muted">
                                                  {{
                                                  "campaign.campaignForm.hintImage"
                                                  | translate
                                                  }}
                                                </p>
                                              </div>
                                            }
                                            <div class="upload-area__image">
                                              @if (headerParams?.value[0]?.value) {
                                                <img
                                                  class="campaign-media-preview"
                                            [src]="
                                              $safeNavigationMigration(headerParams?.value[0]?.value)
                                            "
                                            [alt]="
                                              'campaign.campaignForm.imageAlt'
                                                | translate
                                            "
                                                  (click)="$event.stopPropagation()"
                                                  (error)="onImageCloudAPILoadError()"
                                                  />
                                                <button
                                                  class="btn btn-soft-danger"
                                                  type="button"
                                            (click)="
                                              removeMedia(
                                                $safeNavigationMigration(headerParams?.value[0]?.value)
                                              );
                                              $event.stopPropagation()
                                            "
                                                  >
                                                  <i
                                                    class="mdi mdi-trash-can-outline"
                                                  ></i>
                                                </button>
                                              }
                                            </div>
                                            <input
                                              #localCloudAPIFile
                                              type="file"
                                              accept=".jpeg, .jpg, .png"
                                              (change)="onSelectCloudAPIFile($event)"
                                              />
                                          </div>
                                        </div>
                                      } @else if (
                                        headerComponent.format === "VIDEO"
                                        ) {
                                        <div class="col-lg-12 mb-3">
                                          <div class="upload-area">
                                            @if (loadingSpinner$ | async) {
                                              <loading-component
                                                class="loading"
                                                diameter="20"
                                                />
                                            } @else if (
                                              !headerParams?.value[0]?.value
                                              ) {
                                              <div
                                                class="placeholder-content"
                                                (click)="addCloudAPIFile()"
                                                >
                                                <i
                                                  class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                                                ></i>
                                                <p class="text-primary">
                                                  {{
                                                  "campaign.campaignForm.clickToUpload"
                                                  | translate
                                                  }}
                                                </p>
                                                <p class="text-muted">
                                                  {{
                                                  "campaign.campaignForm.hintVideo"
                                                  | translate
                                                  }}
                                                </p>
                                              </div>
                                            }
                                            <div class="upload-area__image">
                                              @if (headerParams?.value[0]?.value) {
                                                <video
                                                  class="campaign-media-preview"
                                            [src]="
                                              $safeNavigationMigration(headerParams?.value[0]?.value)
                                            "
                                                  controls
                                                  (click)="$event.stopPropagation()"
                                                  (error)="onImageCloudAPILoadError()"
                                                ></video>
                                                <button
                                                  class="btn btn-soft-danger"
                                                  type="button"
                                            (click)="
                                              removeMedia(
                                                $safeNavigationMigration(headerParams?.value[0]?.value)
                                              );
                                              $event.stopPropagation()
                                            "
                                                  >
                                                  <i
                                                    class="mdi mdi-trash-can-outline"
                                                  ></i>
                                                </button>
                                              }
                                            </div>
                                            <input
                                              #localCloudAPIFile
                                              type="file"
                                              accept="video/mp4, video/x-msvideo"
                                              (change)="onSelectCloudAPIFile($event)"
                                              />
                                          </div>
                                        </div>
                                      } @else if (
                                        headerComponent.format === "DOCUMENT"
                                        ) {
                                        <div class="col-lg-12 mb-3">
                                          <div class="upload-area">
                                            @if (loadingSpinner$ | async) {
                                              <loading-component
                                                class="loading"
                                                diameter="20"
                                                />
                                            } @else if (
                                              !headerParams?.value[0]?.value
                                              ) {
                                              <div
                                                class="placeholder-content"
                                                (click)="addCloudAPIFile()"
                                                >
                                                <i
                                                  class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                                                ></i>
                                                <p class="text-primary">
                                                  {{
                                                  "campaign.campaignForm.clickToUpload"
                                                  | translate
                                                  }}
                                                </p>
                                                <p class="text-muted">
                                                  {{
                                                  "campaign.campaignForm.hintDocument"
                                                  | translate
                                                  }}
                                                </p>
                                              </div>
                                            }
                                            <div class="upload-area__image">
                                              @if (headerParams?.value[0]?.value) {
                                                <a
                                            [href]="
                                              $safeNavigationMigration(headerParams?.value[0]?.value)
                                            "
                                                  target="_blank"
                                                  class="mb-2"
                                                  >{{
                                                  "campaign.campaignForm.viewPdf"
                                                  | translate
                                                  }}</a
                                                  >
                                                  <button
                                                    class="btn btn-soft-danger"
                                                    type="button"
                                            (click)="
                                              removeMedia(
                                                $safeNavigationMigration(headerParams?.value[0]?.value)
                                              );
                                              $event.stopPropagation()
                                            "
                                                    >
                                                    <i
                                                      class="mdi mdi-trash-can-outline"
                                                    ></i>
                                                  </button>
                                                }
                                              </div>
                                              <input
                                                #localCloudAPIFile
                                                type="file"
                                                accept="application/pdf"
                                                (change)="onSelectCloudAPIFile($event)"
                                                />
                                            </div>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (bodyParams.controls.length > 0) {
                                    <span class="campaign-group-label">
                                      {{
                                      "campaign.campaignForm.messageVariables"
                                      | translate
                                      }}
                                    </span>
                                    <div class="row" formArrayName="bodyParams">
                                      @for (
                                        body of bodyParams.controls;
                                        track body;
                                        let j = $index
                                        ) {
                                        <div [formGroupName]="j" class="col-12 mb-3">
                                          <label class="form-label"
                                            >{{
                                            "campaign.campaignForm.variableN"
                                            | translate: { n: j + 1 }
                                            }}
                                            <span class="text-danger">*</span></label
                                            >
                                            <input
                                              class="form-control"
                                              matInput
                                              formControlName="value"
                                    [placeholder]="
                                      'campaign.campaignForm.fillMessageVariable'
                                        | translate
                                    "
                                              [matAutocomplete]="autoBody"
                                              (input)="onInputChange('bodys', j + 1)"
                                              (focus)="onInputChange('bodys', j + 1)"
                                              />
                                            <mat-autocomplete
                                              #autoBody="matAutocomplete"
                                    (optionSelected)="
                                      onOptionSelected(
                                        'bodys',
                                        $event.option.viewValue,
                                        j + 1
                                      )
                                    "
                                              >
                                              @for (
                                                option of filteredOptions;
                                                track option
                                                ) {
                                                <mat-option [value]="option.text">{{
                                                  option.text
                                                }}</mat-option>
                                              }
                                            </mat-autocomplete>
                                          </div>
                                        }
                                      </div>
                                    }
                                    @if (buttonParams.controls.length > 0) {
                                      <span class="campaign-group-label">
                                        {{
                                        "campaign.campaignForm.buttonVariables"
                                        | translate
                                        }}
                                      </span>
                                      <div class="row" formArrayName="buttonParams">
                                        @for (
                                          body of buttonParams.controls;
                                          track body;
                                          let j = $index
                                          ) {
                                          <div [formGroupName]="j" class="col-12 mb-3">
                                            <label class="form-label"
                                              >{{
                                              "campaign.campaignForm.buttonVariableN"
                                              | translate: { n: j + 1 }
                                              }}
                                              <span class="text-danger">*</span></label
                                              >
                                              <input
                                                class="form-control"
                                                matInput
                                                formControlName="value"
                                    [placeholder]="
                                      'campaign.campaignForm.fillMessageVariable'
                                        | translate
                                    "
                                                />
                                            </div>
                                          }
                                        </div>
                                      }

                                      @if (isTemplateOverLimit) {
                                        <div
                                          class="campaign-note is-warn mt-3"
                                          role="alert"
                                          >
                                          <i
                                            class="mdi mdi-alert-outline"
                                            aria-hidden="true"
                                          ></i>
                                          <div>
                                            <strong>{{
                                              "campaign.campaignForm.warningLabel"
                                              | translate
                                            }}</strong>
                                            {{
                                            "campaign.campaignForm.templateLimitPart1"
                                            | translate
                                            }}
                                            <strong>{{ templateTotalCharacters }}</strong>
                                            {{
                                            "campaign.campaignForm.templateLimitPart2"
                                            | translate
                                            }}
                                            <strong>{{ META_BODY_CHARACTER_LIMIT }}</strong>
                                            {{
                                            "campaign.campaignForm.templateLimitPart3"
                                            | translate
                                            }}
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            } @else if (isSelectedChannelZAPI()) {
                              <div class="campaign-panel" formGroupName="zapiDataGroup">
                                <div class="row">
                                  <div class="col-xs-12 col-xl-12 mb-3">
                                    <label class="form-label">
                                      {{ "campaign.campaignForm.messageType" | translate }}
                                      <span class="text-danger">*</span>
                                    </label>
                                    <mat-select
                                      class="form-control"
                          [placeholder]="
                            'campaign.campaignForm.selectPlaceholder'
                              | translate
                          "
                                      formControlName="messageType"
                                      (selectionChange)="onMessageTypeChangeZapi()"
                                      >
                                      <mat-option [value]="">{{
                                        "campaign.campaignForm.selectPlaceholder"
                                        | translate
                                      }}</mat-option>
                                      <mat-option [value]="'text'">{{
                                        "campaign.campaignForm.optionText" | translate
                                      }}</mat-option>
                                      <mat-option [value]="'buttons'">{{
                                        "campaign.campaignForm.optionButtons" | translate
                                      }}</mat-option>
                                    </mat-select>
                                    <field-error-component
                                      [field]="'messageType'"
                          [label]="
                            'campaign.campaignForm.messageType' | translate
                          "
                                      [formGroup]="getZAPIFormGroup"
                                      />
                                  </div>

                                  @if (
                                    formGroup.get("zapiDataGroup.messageType")?.value ===
                                    "buttons"
                                    ) {
                                    <div class="col-12">
                                      <app-button-zapi-component
                                        [campaign]="true"
                                        [showFullMessage]="true"
                                        [maxButtons]="3"
                            [buttonActionsArray]="
                              $any(getZAPIFormGroup.get('buttonActions'))
                            "
                            [title]="
                              $safeNavigationMigration($any(getZAPIFormGroup.get('buttonsTitle'))?.value)
                            "
                            [message]="
                              $safeNavigationMigration($any(getZAPIFormGroup.get('buttonsMessage'))
                                ?.value)
                            "
                            [footer]="
                              $safeNavigationMigration($any(getZAPIFormGroup.get('buttonsFooter'))?.value)
                            "
                            (titleChange)="
                              $any(
                                getZAPIFormGroup.get('buttonsTitle')
                              )?.setValue($event)
                            "
                            (messageChange)="
                              $any(
                                getZAPIFormGroup.get('buttonsMessage')
                              )?.setValue($event)
                            "
                            (footerChange)="
                              $any(
                                getZAPIFormGroup.get('buttonsFooter')
                              )?.setValue($event)
                            "
                                        />
                                    </div>
                                  } @else {
                                    <div class="col-lg-12 mb-3">
                                      <label class="form-label"
                                        >{{ "campaign.campaignForm.message" | translate }}
                                        <span class="text-danger">*</span></label
                                        >
                                        <textarea
                                          #messageTextarea
                                          class="form-control"
                                          formControlName="message"
                                          (paste)="onPaste($event)"
                            [placeholder]="
                              'campaign.campaignForm.typePlaceholder'
                                | translate
                            "
                                          rows="8"
                                        ></textarea>
                                        <field-error-component
                                          [field]="'message'"
                            [label]="
                              'campaign.campaignForm.message' | translate
                            "
                                          [formGroup]="getZAPIFormGroup"
                                          />
                                        <div
                                          class="campaign-editor-toolbar"
                                          role="toolbar"
                            [attr.aria-label]="
                              'campaign.campaignForm.editorToolbar' | translate
                            "
                                          >
                                          <button
                                            type="button"
                                            class="campaign-editor-btn"
                                            (click)="applyFormat('bold')"
                                            >
                                            <i
                                              class="mdi mdi-format-bold"
                                              aria-hidden="true"
                                            ></i>
                                          </button>

                                          <button
                                            type="button"
                                            class="campaign-editor-btn"
                                            (click)="applyFormat('italic')"
                                            >
                                            <i
                                              class="mdi mdi-format-italic"
                                              aria-hidden="true"
                                            ></i>
                                          </button>

                                          <button
                                            type="button"
                                            class="campaign-editor-btn"
                                            (click)="applyFormat('strikethrough')"
                                            >
                                            <i
                                              class="mdi mdi-format-strikethrough"
                                              aria-hidden="true"
                                            ></i>
                                          </button>

                                          <div class="position-relative">
                                            <button
                                              type="button"
                                              class="campaign-editor-btn"
                                              (click)="toogleContainerEmoji()"
                                              >
                                              <i
                                                class="mdi mdi-emoticon-outline"
                                                aria-hidden="true"
                                              ></i>
                                            </button>

                                            @if (showContainerEmoji) {
                                              <div
                                                #emojiContainer
                                                id="emoji-container"
                                                class="position-absolute start-0 mt-2 z-3"
                                                (click)="$event.stopPropagation()"
                                                >
                                                <emoji-mart
                                                  (emojiSelect)="addEmoji($event)"
                                                  [i18n]="translator"
                                                  [darkMode]="false"
                                                  >
                                                </emoji-mart>
                                              </div>
                                            }
                                          </div>

                                          <button
                                            type="button"
                                            class="campaign-editor-btn"
                                            [matMenuTriggerFor]="menuVar"
                                            >
                                            <i
                                              class="mdi mdi-code-tags"
                                              aria-hidden="true"
                                            ></i>
                                          </button>

                                          <mat-menu #menuVar="matMenu">
                                            <button
                                              mat-menu-item
                                              (click)="selectVarContactZAPI()"
                                              >
                                              <i
                                                class="mdi mdi-account"
                                                aria-hidden="true"
                                              ></i>
                                              {{
                                              "campaign.campaignForm.contactName"
                                              | translate
                                              }}
                                            </button>
                                          </mat-menu>
                                        </div>
                                      </div>
                                      <div class="col-lg-12 mb-3">
                                        <div class="upload-area">
                                          @if (loadingSpinner$ | async) {
                                            <loading-component
                                              class="loading"
                                              diameter="20"
                                              />
                                          } @else if (
                                            !formGroup.get("zapiDataGroup.midia")?.value
                                            ) {
                                            <div
                                              class="placeholder-content"
                                              (click)="addZAPIFile()"
                                              >
                                              <i
                                                class="mdi mdi-cloud-upload-outline upload-icon text-primary"
                                              ></i>
                                              <p class="text-primary">
                                                {{
                                                "campaign.campaignForm.clickToUpload"
                                                | translate
                                                }}
                                              </p>
                                              <p class="text-muted">
                                                {{
                                                "campaign.campaignForm.hintImage"
                                                | translate
                                                }}
                                                <br />
                                                {{
                                                "campaign.campaignForm.hintVideo"
                                                | translate
                                                }}
                                                <br />
                                                {{
                                                "campaign.campaignForm.hintDocument"
                                                | translate
                                                }}
                                              </p>
                                            </div>
                                          }
                                          <div class="upload-area__image">
                                            @if (
                                              formGroup.get("zapiDataGroup.midia")?.value
                                              ) {
                                              @if (
                                                formGroup.get("zapiDataGroup.type")?.value ===
                                                "image"
                                                ) {
                                                <img
                                                  class="campaign-media-preview"
                                    [src]="
                                      $safeNavigationMigration(formGroup.get('zapiDataGroup.midia')
                                        ?.value)
                                    "
                                    [alt]="
                                      'campaign.campaignForm.imageAlt'
                                        | translate
                                    "
                                                  (click)="$event.stopPropagation()"
                                                  (error)="onImageZAPILoadError()"
                                                  />
                                              } @else if (
                                                formGroup.get("zapiDataGroup.type")?.value ===
                                                "video"
                                                ) {
                                                <video
                                                  class="campaign-media-preview"
                                    [src]="
                                      $safeNavigationMigration(formGroup.get('zapiDataGroup.midia')
                                        ?.value)
                                    "
                                                  controls
                                                  (click)="$event.stopPropagation()"
                                                ></video>
                                              } @else if (
                                                formGroup.get("zapiDataGroup.type")?.value ===
                                                "document"
                                                ) {
                                                <div
                                                  class="d-flex flex-column align-items-center"
                                                  >
                                                  <a
                                      [href]="
                                        $safeNavigationMigration(formGroup.get('zapiDataGroup.midia')
                                          ?.value)
                                      "
                                                    target="_blank"
                                                    class="mb-2"
                                                    >{{
                                                    "campaign.campaignForm.viewPdf"
                                                    | translate
                                                    }}</a
                                                    >
                                                  </div>
                                                }
                                                <button
                                                  class="btn btn-soft-danger"
                                                  type="button"
                                  (click)="
                                    removeMedia(
                                      $safeNavigationMigration(formGroup.get('zapiDataGroup.midia')
                                        ?.value)
                                    );
                                    $event.stopPropagation()
                                  "
                                                  >
                                                  <i class="mdi mdi-trash-can-outline"></i>
                                                </button>
                                              }
                                            </div>
                                            <input
                                              #localZAPIFile
                                              type="file"
                                              (change)="onSelectZAPIFile($event)"
                                              />
                                          </div>
                                          <field-error-component
                                            [field]="'midia'"
                            [label]="
                              'campaign.campaignForm.imageUrlLabel' | translate
                            "
                                            [formGroup]="getZAPIFormGroup"
                                            />
                                        </div>
                                      }
                                    </div>
                                  </div>
                                } @else if (isSelectedChannelRcsAPI()) {
                                  <!-- The RCS composer is shared with the webhook integration (RcsMessageModule). -->
                                  <rcs-message-editor
                                    [group]="getRCSFormGroup"
                                    [variables]="rcsVariables"
                                    />
                                }
                              </div>
                              <div class="campaign-form-actions">
                                <button
                                  type="button"
                                  class="btn btn-light"
                                  (click)="previousStep()"
                                  >
                                  {{ "campaign.campaignForm.back" | translate }}
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  (click)="nextStep()"
                                  [disabled]="disableNextMessage()"
                                  >
                                  {{ "campaign.campaignForm.next" | translate }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-xl-4">
                          <div class="campaign-rail">
                            <ng-container [ngTemplateOutlet]="previewRail" />
                            <ng-container [ngTemplateOutlet]="summaryRail" />
                            <ng-container [ngTemplateOutlet]="rcsBillingRail" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane"
                      id="recipient"
                      role="tabpanel"
                      [class.active]="stepIndex() === 2"
                      [class.show]="stepIndex() === 2"
                      >
                      <div class="row">
                        <div class="col-12 col-xl-8">
                          <div class="card campaign-step-card">
                            <div class="card-body">
                              <ng-container [ngTemplateOutlet]="stepperNav" />
                              <div class="campaign-step-scroll">
                                <div class="mb-3">
                                  <h4 class="header-title mb-1">
                                    {{ "campaign.campaignForm.audienceHeading" | translate }}
                                  </h4>
                                  <p class="text-muted mb-0">
                                    {{
                                    "campaign.campaignForm.audienceFrozenNotice" | translate
                                    }}
                                  </p>
                                </div>
                                ˝
                                <div class="campaign-picks is-grid">
                                  <label
                                    class="campaign-pick"
                                    [class.is-selected]="isAudienceSourceBase()"
                                    >
                                    <input
                                      type="radio"
                                      [value]="'BASE'"
                                      formControlName="audienceSource"
                                      class="campaign-pick-input"
                                      (change)="selectAudienceSource(AudienceSource.BASE)"
                                      />
                                    <span class="campaign-pick-radio" aria-hidden="true"></span>
                                    <span class="campaign-pick-body">
                                      <b>{{
                                        "campaign.campaignForm.audienceFromBase" | translate
                                      }}</b>
                                      <span>{{
                                        "campaign.campaignForm.audienceFromBaseDesc" | translate
                                      }}</span>
                                    </span>
                                  </label>

                                  <label
                                    class="campaign-pick"
                                    [class.is-selected]="isAudienceSourceFileNew()"
                                    >
                                    <input
                                      type="radio"
                                      [value]="'FILE_NEW'"
                                      formControlName="audienceSource"
                                      class="campaign-pick-input"
                                      (change)="selectAudienceSource(AudienceSource.FILE_NEW)"
                                      />
                                    <span class="campaign-pick-radio" aria-hidden="true"></span>
                                    <span class="campaign-pick-body">
                                      <b>{{
                                        "campaign.campaignForm.audienceUploadNow" | translate
                                      }}</b>
                                      <span>{{
                                        "campaign.campaignForm.audienceUploadNowDesc"
                                        | translate
                                      }}</span>
                                    </span>
                                  </label>

                                  <label
                                    class="campaign-pick"
                                    [class.is-selected]="isAudienceSourceFileExisting()"
                                    >
                                    <input
                                      type="radio"
                                      [value]="'FILE_EXISTING'"
                                      formControlName="audienceSource"
                                      class="campaign-pick-input"
                      (change)="
                        selectAudienceSource(AudienceSource.FILE_EXISTING)
                      "
                                      />
                                    <span class="campaign-pick-radio" aria-hidden="true"></span>
                                    <span class="campaign-pick-body">
                                      <b>{{
                                        "campaign.campaignForm.audienceExistingList" | translate
                                      }}</b>
                                      <span>{{
                                        "campaign.campaignForm.audienceExistingListDesc"
                                        | translate
                                      }}</span>
                                    </span>
                                  </label>
                                </div>

                                @if (isAudienceSourceBase()) {
                                  <div class="campaign-picks mt-3">
                                    <label
                                      class="campaign-pick"
                                      [class.is-selected]="isAudienceTypeAllLeads()"
                                      >
                                      <input
                                        type="radio"
                                        [value]="'ALL_LEADS'"
                                        formControlName="audienceType"
                                        class="campaign-pick-input"
                                        />
                                      <span
                                        class="campaign-pick-radio"
                                        aria-hidden="true"
                                      ></span>
                                      <i
                                        class="campaign-pick-icon mdi mdi-account-group-outline"
                                        aria-hidden="true"
                                      ></i>
                                      <span class="campaign-pick-body">
                                        <b>{{
                                          "campaign.campaignForm.allContacts" | translate
                                        }}</b>
                                        <span>{{
                                          "campaign.campaignForm.allContactsDesc" | translate
                                        }}</span>
                                      </span>
                                    </label>

                                    <label
                                      class="campaign-pick"
                                      [class.is-selected]="isAudienceTypeTags()"
                                      >
                                      <input
                                        type="radio"
                                        [value]="'TAGS'"
                                        formControlName="audienceType"
                                        class="campaign-pick-input"
                                        />
                                      <span
                                        class="campaign-pick-radio"
                                        aria-hidden="true"
                                      ></span>
                                      <i
                                        class="campaign-pick-icon mdi mdi-filter-variant"
                                        aria-hidden="true"
                                      ></i>
                                      <span class="campaign-pick-body">
                                        <b>{{ "campaign.campaignForm.byTag" | translate }}</b>
                                        <span>{{
                                          "campaign.campaignForm.byTagDesc" | translate
                                        }}</span>
                                      </span>
                                    </label>

                                    <label
                                      class="campaign-pick"
                                      [class.is-selected]="isAudienceTypeContactGroups()"
                                      >
                                      <input
                                        type="radio"
                                        [value]="'CONTACT_GROUP'"
                                        formControlName="audienceType"
                                        class="campaign-pick-input"
                                        />
                                      <span
                                        class="campaign-pick-radio"
                                        aria-hidden="true"
                                      ></span>
                                      <i
                                        class="campaign-pick-icon mdi mdi-account-multiple-outline"
                                        aria-hidden="true"
                                      ></i>
                                      <span class="campaign-pick-body">
                                        <b>{{
                                          "campaign.campaignForm.byContactGroup" | translate
                                        }}</b>
                                        <span>{{
                                          "campaign.campaignForm.byContactGroupDesc" | translate
                                        }}</span>
                                      </span>
                                    </label>
                                  </div>
                                  @if (isAudienceTypeAllLeads()) {
                                  } @else if (isAudienceTypeTags()) {
                                    <div class="campaign-panel mt-2">
                                      <div class="row">
                                        <div class="col-12">
                                          <label class="form-label">
                                            {{ "campaign.campaignForm.tags" | translate }}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <mat-select
                                            class="form-control"
                                            formControlName="tags"
                            (selectionChange)="
                              onAudienceItemsSelected('tag', $event)
                            "
                            [placeholder]="
                              'campaign.campaignForm.selectTagsPlaceholder'
                                | translate
                            "
                                            multiple
                                            #tags
                                            >
                                            <div class="p-2">
                                              <input
                                                class="form-control"
                                                type="text"
                                                (focus)="onFocusTags()"
                                                [formControl]="filterControlTag"
                                [placeholder]="
                                  'campaign.campaignForm.searchTagsPlaceholder'
                                    | translate
                                "
                                                />
                                            </div>
                                            @for (item of allTags; track item) {
                                              <mat-option [value]="item._id">
                                                {{ item.title }}
                                                <span class="badge bg-soft-secondary ms-1">
                                                  @if (
                                                    audienceItemCount("tag", item._id) === null
                                                    ) {
                                                    <span
                                                      class="spinner-border spinner-border-sm"
                                                      role="status"
                                                    ></span>
                                                  } @else {
                                                    {{
                                                    audienceItemCount("tag", item._id)
                                                    | number: "1.0-0"
                                                    }}
                                                  }
                                                </span>
                                              </mat-option>
                                            }
                                          </mat-select>
                                          <field-error-component
                                            [field]="'tags'"
                                            [label]="'campaign.campaignForm.tags' | translate"
                                            [formGroup]="formGroup"
                                            />
                                        </div>
                                      </div>
                                    </div>
                                  } @else if (isAudienceTypeContactGroups()) {
                                    <div class="campaign-panel mt-2">
                                      <div class="row">
                                        <div class="col-12">
                                          <label class="form-label">
                                            {{
                                            "campaign.campaignForm.contactGroups" | translate
                                            }}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <mat-select
                                            class="form-control"
                                            formControlName="contactGroups"
                            (selectionChange)="
                              onAudienceItemsSelected('group', $event)
                            "
                            [placeholder]="
                              'campaign.campaignForm.selectContactGroupsPlaceholder'
                                | translate
                            "
                                            multiple
                                            #tags
                                            >
                                            <div class="p-2">
                                              <input
                                                class="form-control"
                                                type="text"
                                                (focus)="onFocusGroup()"
                                                [formControl]="filterControlGroup"
                                [placeholder]="
                                  'campaign.campaignForm.searchGroupPlaceholder'
                                    | translate
                                "
                                                />
                                            </div>
                                            @for (item of allGroups; track item) {
                                              <mat-option [value]="item._id">
                                                {{ item.name }}
                                                <span class="badge bg-soft-secondary ms-1">
                                                  @if (
                                                    audienceItemCount("group", item._id) ===
                                                    null
                                                    ) {
                                                    <span
                                                      class="spinner-border spinner-border-sm"
                                                      role="status"
                                                    ></span>
                                                  } @else {
                                                    {{
                                                    audienceItemCount("group", item._id)
                                                    | number: "1.0-0"
                                                    }}
                                                  }
                                                </span>
                                              </mat-option>
                                            }
                                          </mat-select>
                                          <field-error-component
                                            [field]="'contactGroups'"
                            [label]="
                              'campaign.campaignForm.contactGroups' | translate
                            "
                                            [formGroup]="formGroup"
                                            />
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  @if (isAudienceTypeAllLeads()) {
                                    <div class="campaign-panel mt-2">
                                      <div class="row">
                                        <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
                                          <label class="form-label">
                                            {{ "campaign.campaignForm.ignoreTags" | translate }}
                                          </label>
                                          <mat-select
                                            class="form-control"
                                            formControlName="ignoredTags"
                            [placeholder]="
                              'campaign.campaignForm.selectTagsPlaceholder'
                                | translate
                            "
                                            multiple
                                            >
                                            <div class="p-2">
                                              <input
                                                class="form-control"
                                                type="text"
                                                (focus)="onFocusTags()"
                                                [formControl]="filterControlTag"
                                [placeholder]="
                                  'campaign.campaignForm.searchTagsPlaceholder'
                                    | translate
                                "
                                                />
                                            </div>
                                            @for (item of allTags; track item) {
                                              <mat-option [value]="item._id">
                                                {{ item.title }}
                                                <span class="badge bg-soft-secondary ms-1">
                                                  @if (
                                                    audienceItemCount("tag", item._id) === null
                                                    ) {
                                                    <span
                                                      class="spinner-border spinner-border-sm"
                                                      role="status"
                                                    ></span>
                                                  } @else {
                                                    {{
                                                    audienceItemCount("tag", item._id)
                                                    | number: "1.0-0"
                                                    }}
                                                  }
                                                </span>
                                              </mat-option>
                                            }
                                          </mat-select>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
                                          <label class="form-label">
                                            {{
                                            "campaign.campaignForm.ignoreContactGroups"
                                            | translate
                                            }}
                                          </label>
                                          <mat-select
                                            class="form-control"
                                            formControlName="ignoredContactGroups"
                            [placeholder]="
                              'campaign.campaignForm.selectContactGroupsPlaceholder'
                                | translate
                            "
                                            multiple
                                            >
                                            <div class="p-2">
                                              <input
                                                class="form-control"
                                                type="text"
                                                (focus)="onFocusGroup()"
                                                [formControl]="filterControlGroup"
                                [placeholder]="
                                  'campaign.campaignForm.searchGroupPlaceholder'
                                    | translate
                                "
                                                />
                                            </div>
                                            @for (item of allGroups; track item) {
                                              <mat-option [value]="item._id">
                                                {{ item.name }}
                                                <span class="badge bg-soft-secondary ms-1">
                                                  @if (
                                                    audienceItemCount("group", item._id) ===
                                                    null
                                                    ) {
                                                    <span
                                                      class="spinner-border spinner-border-sm"
                                                      role="status"
                                                    ></span>
                                                  } @else {
                                                    {{
                                                    audienceItemCount("group", item._id)
                                                    | number: "1.0-0"
                                                    }}
                                                  }
                                                </span>
                                              </mat-option>
                                            }
                                          </mat-select>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                } @else {
                                  <div class="campaign-panel mt-3">
                                    <div class="row justify-content-center mb-4">
                                      <div class="col-10 p-3">
                                        <div class="horizontal-steps">
                                          <div class="horizontal-steps-content">
                                            <div
                                              class="step-item"
                                              [class.current]="audienceFileStep === 0"
                                              >
                                              <span>{{
                                                "shared.contactUploadCsv.stepLoad" | translate
                                              }}</span>
                                            </div>
                                            <div
                                              class="step-item"
                                              [class.current]="audienceFileStep === 1"
                                              >
                                              <span>{{
                                                "shared.contactUploadCsv.stepMap" | translate
                                              }}</span>
                                            </div>
                                            <div
                                              class="step-item"
                                              [class.current]="audienceFileStep === 2"
                                              >
                                              <span>{{
                                                "shared.contactUploadCsv.stepPreview"
                                                | translate
                                              }}</span>
                                            </div>
                                          </div>
                                          <div
                                            class="process-line"
                                            [style.width]="(audienceFileStep / 2) * 100 + '%'"
                                          ></div>
                                        </div>
                                      </div>
                                    </div>

                                    @switch (audienceFileStep) {
                                      @case (0) {
                                        @if (isAudienceSourceFileNew()) {
                                          @if (!audienceFileName) {
                                            <label
                                              for="campaign-audience-dropzone"
                                              class="campaign-dz-area w-100"
                                              role="button"
                              [attr.aria-label]="
                                'campaign.campaignForm.audienceFileDropzoneAriaLabel'
                                  | translate
                              "
                                              >
                                              <div class="campaign-dz-inner text-center">
                                                <i
                                                  class="mdi mdi-cloud-upload-outline mb-2 campaign-dz-icon"
                                                ></i>
                                                <div class="fw-semibold fs-5 mb-1">
                                                  {{
                                                  "campaign.campaignForm.audienceFileClickToUpload"
                                                  | translate
                                                  }}
                                                </div>
                                                <small class="text-muted d-block">
                                                  {{
                                                  "campaign.campaignForm.audienceFileAccepted"
                                                  | translate
                                                  }}
                                                </small>
                                                <small class="text-muted d-block">
                                                  {{
                                                  "campaign.campaignForm.audienceFileLimits"
                                                  | translate
                                                  : {
                                                  rows: AUDIENCE_FILE_MAX_ROWS,
                                                  mb: 5,
                                                }
                                                }}
                                              </small>
                                            </div>
                                          </label>
                                          <input
                                            id="campaign-audience-dropzone"
                                            type="file"
                                            class="d-none"
                                            accept=".csv,.xlsx"
                                            (change)="onSelectAudienceFile($event)"
                                            #localAudienceFile
                                            />
                                          <p class="campaign-field-hint mt-2 mb-0">
                                            {{
                                            "campaign.campaignForm.audienceFileColumnsHint"
                                            | translate
                                            }}
                                          </p>
                                        } @else {
                                          <div
                                            class="d-flex align-items-center justify-content-between gap-2"
                                            >
                                            <div class="d-flex align-items-center gap-2">
                                              <i
                                                class="mdi mdi-file-check-outline campaign-dz-icon"
                                              ></i>
                                              <div class="d-flex flex-column">
                                                <span class="fw-semibold">{{
                                                  audienceFileName
                                                }}</span>
                                                <span class="small text-muted">
                                                  {{ audienceFileSize }} ·
                                                  {{
                                                  "campaign.campaignForm.audienceFileRowsSummary"
                                                  | translate
                                                  : {
                                                  valid: audienceFileValidRows,
                                                  total: audienceFileTotalRows,
                                                }
                                                }}
                                              </span>
                                            </div>
                                          </div>
                                          <button
                                            type="button"
                                            class="btn btn-sm btn-soft-danger"
                                            (click)="clearAudienceFile()"
                                            >
                                            <i class="mdi mdi-trash-can-outline"></i>
                                          </button>
                                        </div>
                                      }
                                    } @else {
                                      <div class="row">
                                        <div class="col-12">
                                          <label class="form-label">
                                            {{
                                            "campaign.campaignForm.audienceFileSelectPrevious"
                                            | translate
                                            }}
                                            <span class="text-danger">*</span>
                                          </label>
                                          <mat-select
                                            class="form-control"
                                            formControlName="audienceFile"
                                [placeholder]="
                                  'campaign.campaignForm.audienceFileSelectPlaceholder'
                                    | translate
                                "
                                (selectionChange)="
                                  onSelectExistingAudienceFile($event.value)
                                "
                                            >
                                            @for (
                                              item of availableAudienceFiles;
                                              track item._id
                                              ) {
                                              <mat-option [value]="item._id">
                                                {{ item.filename }} ·
                                                {{ item.createdAt | date: "dd/MM/yyyy" }} ·
                                                {{
                                                "campaign.campaignForm.audienceFileRowsSummary"
                                                | translate
                                                : {
                                                valid: item.validRows,
                                                total: item.totalRows,
                                              }
                                              }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                        @if (!availableAudienceFiles?.length) {
                                          <p class="campaign-field-hint mt-2 mb-0">
                                            {{
                                            "campaign.campaignForm.audienceFileNoneAvailable"
                                            | translate
                                            }}
                                          </p>
                                        }
                                      </div>
                                    </div>

                                    @if (audienceFilePreviewLoading) {
                                      <div class="text-center mt-3">
                                        <span
                                          class="spinner-border spinner-border-sm text-muted"
                                          role="status"
                                        ></span>
                                      </div>
                                    } @else if (audienceFilePreviewFailed) {
                                      <p class="campaign-field-hint mt-3 mb-0">
                                        {{
                                        "campaign.campaignForm.audienceFilePreviewUnavailable"
                                        | translate
                                        }}
                                      </p>
                                    }
                                  }
                                }
                                @case (1) {
                                  <ng-container
                                    [ngTemplateOutlet]="audienceColumnMapping"
                                    />
                                }
                                @case (2) {
                                  <ng-container
                                    [ngTemplateOutlet]="audienceFilePreview"
                                    />
                                }
                              }

                              <div class="d-flex justify-content-end gap-2 mt-3">
                                @if (audienceFileStep > 0) {
                                  <button
                                    type="button"
                                    class="btn btn-light"
                                    (click)="audienceFileStep = audienceFileStep - 1"
                                    >
                                    {{ "shared.contactUploadCsv.back" | translate }}
                                  </button>
                                }
                                @if (audienceFileStep === 0) {
                                  <button
                                    type="button"
                                    class="btn btn-primary"
                                    [disabled]="!audienceFileColumns.length"
                                    (click)="audienceFileStep = 1"
                                    >
                                    {{ "shared.contactUploadCsv.continue" | translate }}
                                  </button>
                                } @else if (audienceFileStep === 1) {
                                  <button
                                    type="button"
                                    class="btn btn-primary"
                          [disabled]="
                            !audienceFileMappings.phone ||
                            (loadingSpinner$ | async)
                          "
                                    (click)="confirmAudienceMapping()"
                                    >
                                    {{ "shared.contactUploadCsv.continue" | translate }}
                                  </button>
                                }
                              </div>

                              <div class="campaign-note is-brand mt-3">
                                <i class="mdi mdi-information-outline"></i>
                                <span>{{
                                  "campaign.campaignForm.audienceFileEphemeralNotice"
                                  | translate
                                }}</span>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="campaign-form-actions">
                          <button
                            type="button"
                            class="btn btn-light"
                            (click)="previousStep()"
                            >
                            {{ "campaign.campaignForm.back" | translate }}
                          </button>
                          <button
                            type="button"
                            class="btn btn-primary"
                            (click)="nextStep()"
                            [disabled]="disableNextRecipient()"
                            >
                            {{ "campaign.campaignForm.next" | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-xl-4">
                    <div class="campaign-rail">
                      <ng-container [ngTemplateOutlet]="previewRail" />
                      <ng-container [ngTemplateOutlet]="summaryRail" />
                      <ng-container [ngTemplateOutlet]="rcsBillingRail" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane"
                id="scheduling"
                role="tabpanel"
                [class.active]="stepIndex() === 3"
                [class.show]="stepIndex() === 3"
                >
                <div class="row">
                  <div class="col-12 col-xl-8">
                    <div class="card campaign-step-card">
                      <div class="card-body">
                        <ng-container [ngTemplateOutlet]="stepperNav" />
                        <div class="campaign-step-scroll">
                          <div class="mb-3">
                            <h4 class="header-title mb-1">
                              {{ "campaign.campaignForm.whenToSend" | translate }}
                            </h4>
                            <p class="text-muted mb-0">
                              {{ "campaign.campaignForm.whenToSendSubtitle" | translate }}
                            </p>
                          </div>
                          <div class="campaign-picks">
                            <label
                              class="campaign-pick"
                              [class.is-selected]="isExecutionTypeImediate()"
                              >
                              <input
                                type="radio"
                                [value]="'IMEDIATE'"
                                formControlName="executionType"
                                class="campaign-pick-input"
                                />
                              <span class="campaign-pick-radio" aria-hidden="true"></span>
                              <i
                                class="campaign-pick-icon mdi mdi-send-outline"
                                aria-hidden="true"
                              ></i>
                              <span class="campaign-pick-body">
                                <b>{{ "campaign.campaignForm.sendNow" | translate }}</b>
                                <span>{{
                                  "campaign.campaignForm.sendNowDesc" | translate
                                }}</span>
                              </span>
                            </label>

                            <label
                              class="campaign-pick"
                              [class.is-selected]="isExecutionTypeScheduled()"
                              >
                              <input
                                type="radio"
                                [value]="'SCHEDULED'"
                                formControlName="executionType"
                                class="campaign-pick-input"
                                />
                              <span class="campaign-pick-radio" aria-hidden="true"></span>
                              <i
                                class="campaign-pick-icon mdi mdi-clock-outline"
                                aria-hidden="true"
                              ></i>
                              <span class="campaign-pick-body">
                                <b>{{
                                  "campaign.campaignForm.scheduleSend" | translate
                                }}</b>
                                <span>{{
                                  "campaign.campaignForm.scheduleSendDesc" | translate
                                }}</span>
                              </span>
                            </label>
                          </div>
                          <div class="campaign-panel mt-2">
                            <div class="row">
                              @if (isExecutionTypeScheduled()) {
                                <div class="col-sm-12 col-md-6 mb-3">
                                  <label class="form-label" for="scheduledDay"
                                    >{{ "campaign.campaignForm.date" | translate }}
                                    <span class="text-danger">*</span></label
                                    >
                                    <div class="trend-datepicker">
                                      <input
                                        class="form-control"
                                        [matDatepicker]="picker"
                                        placeholder="00/00/0000"
                                        formControlName="scheduledDay"
                                        [disabled]="true"
                                        />
                                      <mat-datepicker-toggle matSuffix [for]="picker" />
                                      <mat-datepicker #picker></mat-datepicker>
                                    </div>
                                  </div>
                                  <div class="col-sm-12 col-md-6 mb-3">
                                    <label class="form-label"
                                      >{{ "campaign.campaignForm.time" | translate }}
                                      <span class="text-danger">*</span></label
                                      >
                                      <input
                                        class="form-control"
                                        formControlName="scheduledHour"
                                        [mask]="'00:00'"
                                        [dropSpecialCharacters]="false"
                          [placeholder]="
                            'campaign.campaignForm.timePlaceholder' | translate
                          "
                                        pattern="^([01]\d|2[0-3]):([0-5]\d)$"
                                        />
                                      <field-error-component
                                        [field]="'scheduledHour'"
                                        [label]="'campaign.campaignForm.time' | translate"
                                        [formGroup]="formGroup"
                                        />
                                    </div>
                                  }
                                  @if (isSelectedChannelZAPI()) {
                                    <div class="col-md-12 mb-3">
                                      <label class="form-label">
                                        {{ "campaign.campaignForm.delaySeconds" | translate }}
                                      </label>
                                      <input
                                        class="form-control"
                                        type="number"
                                        min="0"
                                        max="15"
                                        formControlName="delayInSeconds"
                          [placeholder]="
                            'campaign.campaignForm.delaySeconds' | translate
                          "
                                        />
                                      <field-error-component
                                        [field]="'delayInSeconds'"
                          [label]="
                            'campaign.campaignForm.delayLabel' | translate
                          "
                                        [formGroup]="formGroup"
                                        />
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="campaign-form-actions">
                              <button
                                type="button"
                                class="btn btn-light"
                                (click)="previousStep()"
                                >
                                {{ "campaign.campaignForm.back" | translate }}
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary"
                                (click)="nextStep()"
                                [disabled]="disableNextScheduling()"
                                >
                                {{ "campaign.campaignForm.next" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-xl-4">
                        <div class="campaign-rail">
                          <ng-container [ngTemplateOutlet]="previewRail" />
                          <ng-container [ngTemplateOutlet]="summaryRail" />
                          <ng-container [ngTemplateOutlet]="rcsBillingRail" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane"
                    id="review"
                    role="tabpanel"
                    [class.active]="stepIndex() === 4"
                    [class.show]="stepIndex() === 4"
                    >
                    <div class="row">
                      <div class="col-12 col-xl-8">
                        <div class="card campaign-step-card">
                          <div class="card-body">
                            <ng-container [ngTemplateOutlet]="stepperNav" />
                            <div class="campaign-step-scroll">
                              <div class="mb-3">
                                <h4 class="header-title mb-1">
                                  {{ "campaign.campaignForm.campaignReview" | translate }}
                                </h4>
                                <p class="text-muted mb-0">
                                  {{
                                  "campaign.campaignForm.campaignReviewSubtitle" | translate
                                  }}
                                </p>
                              </div>
                              <div class="campaign-panel">
                                <div class="campaign-panel-head mb-3">
                                  <span class="campaign-panel-icon" aria-hidden="true"
                                    ><i class="mdi mdi-chat-outline"></i
                                  ></span>
                                  <div>
                                    <b>{{
                                      "campaign.campaignForm.sendingChannel" | translate
                                    }}</b>
                                  </div>
                                </div>
                                <div class="campaign-sum-line">
                                  <span class="k">{{
                                    "campaign.campaignForm.campaignName" | translate
                                  }}</span>
                                  <span class="v">{{ formGroup.get("name")?.value }}</span>
                                </div>
                                <div class="campaign-sum-line">
                                  <span class="k">{{
                                    "campaign.campaignForm.channelLabel" | translate
                                  }}</span>
                                  <span class="v">
                                    {{ selectedChannel?.name }}
                                    <small>{{
                                      channelTypeKey(selectedChannel) | translate
                                    }}</small>
                                  </span>
                                </div>
                              </div>

                              <div class="campaign-panel mt-3">
                                <div class="campaign-panel-head mb-3">
                                  <span class="campaign-panel-icon" aria-hidden="true"
                                    ><i class="mdi mdi-account-group-outline"></i
                                  ></span>
                                  <div>
                                    <b>{{
                                      "campaign.campaignForm.recipients" | translate
                                    }}</b>
                                  </div>
                                </div>
                                <div class="campaign-sum-line">
                                  <span class="k">{{
                                    "campaign.campaignForm.leadsCount" | translate
                                  }}</span>
                                  <span class="v">
                                    {{ audienceSummary?.totalToSend ?? 0 | number: "1.0-0" }}
                                  </span>
                                </div>
                                <div class="campaign-sum-line">
                                  <span class="k">{{
                                    "campaign.campaignForm.audienceLabel" | translate
                                  }}</span>
                                  <span class="v">{{ summaryOriginText || "—" }}</span>
                                </div>
                                @if (isSelectedChannelCloudAPI()) {
                                  <div class="campaign-sum-line campaign-sum-total">
                                    <span class="k">{{
                                      "campaign.campaignForm.cost" | translate
                                    }}</span>
                                    <span class="v">
                                      @if (
                                        summaryAwaitingTemplate ||
                                        summaryUnpriced ||
                                        summaryPriceLoading
                                        ) {
                                        @if (summaryPriceLoading) {
                                          <span
                                            class="spinner-border spinner-border-sm text-muted"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        } @else {
                                          <span class="text-muted">{{
                                            summaryUnpricedLabel | translate
                                          }}</span>
                                        }
                                      } @else {
                                        {{
                                        cost
                                        | currency
                                        : summaryPriceCurrency
                                        : "symbol"
                                        : "1.2-2"
                                        }}
                                      }
                                    </span>
                                  </div>
                                }
                              </div>

                              <div class="campaign-panel mt-3">
                                <div class="campaign-panel-head mb-3">
                                  <span class="campaign-panel-icon" aria-hidden="true"
                                    ><i class="mdi mdi-clock-outline"></i
                                  ></span>
                                  <div>
                                    <b>{{
                                      "campaign.campaignForm.scheduling" | translate
                                    }}</b>
                                  </div>
                                </div>
                                <div class="campaign-sum-line">
                                  <span class="k">{{
                                    "campaign.campaignForm.whenToSend" | translate
                                  }}</span>
                                  <span class="v">
                                    @if (isExecutionTypeImediate()) {
                                      {{ "campaign.campaignForm.immediateSend" | translate }}
                                    } @else if (isExecutionTypeScheduled()) {
                                      {{
                                      $safeNavigationMigration(formGroup.get("scheduledDay")?.value)
                                      | date: "dd/MM/yyyy"
                                      }}
                                      {{ "campaign.campaignForm.atSeparator" | translate }}
                                      {{ formGroup.get("scheduledHour")?.value }}
                                    }
                                  </span>
                                </div>
                                @if (isSelectedChannelZAPI()) {
                                  <div class="campaign-sum-line">
                                    <span class="k">{{
                                      "campaign.campaignForm.delayLabel" | translate
                                    }}</span>
                                    <span class="v">
                                      {{ formGroup.get("delayInSeconds")?.value || 0 }}
                                      {{ "campaign.campaignForm.secondsSuffix" | translate }}
                                    </span>
                                  </div>
                                }
                              </div>
                              <div class="campaign-panel mt-3">
                                <div class="custom-switch">
                                  <input
                                    type="checkbox"
                                    id="enabled"
                                    checked
                                    data-switch="success"
                                    formControlName="enabled"
                                    />
                                  <label for="enabled">
                                    @if (formGroup.get("enabled").value === false) {
                                      <span class="text-muted">{{
                                        "campaign.campaignForm.enableToSend" | translate
                                      }}</span>
                                    } @else {
                                      <span class="text-muted">{{
                                        "campaign.campaignForm.campaignEnabled" | translate
                                      }}</span>
                                    }
                                  </label>
                                </div>
                                <div class="campaign-field-hint">
                                  @if (formGroup.get("enabled").value === false) {
                                    {{ "campaign.campaignForm.draftStatusPart1" | translate }}
                                    <span class="fw-bold text-warning">{{
                                      "campaign.campaignForm.draftStatusKeyword" | translate
                                    }}</span>
                                    {{ "campaign.campaignForm.draftStatusPart2" | translate }}
                                  } @else {
                                    {{ "campaign.campaignForm.readyStatusPart1" | translate }}
                                    <span class="fw-bold text-success">{{
                                      "campaign.campaignForm.readyStatusKeyword" | translate
                                    }}</span>
                                    {{ "campaign.campaignForm.readyStatusPart2" | translate }}
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="campaign-form-actions">
                              <button
                                type="button"
                                class="btn btn-light"
                                (click)="previousStep()"
                                >
                                {{ "campaign.campaignForm.back" | translate }}
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary"
                                (click)="confirmSaveCampaign()"
                                >
                                {{ "campaign.campaignForm.save" | translate }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-xl-4">
                        <div class="campaign-rail">
                          <ng-container [ngTemplateOutlet]="previewRail" />
                          <ng-container [ngTemplateOutlet]="summaryRail" />
                          <ng-container [ngTemplateOutlet]="rcsBillingRail" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- tab-content -->
              </form>

              <ng-template #audienceColumnMapping>
                @if (!audienceFileMappings.phone) {
                  <div class="alert alert-warning py-2 mb-3" role="alert">
                    <i class="mdi mdi-alert-circle-outline me-1"></i>
                    {{ "campaign.campaignForm.audienceFileMissingPhoneColumn" | translate }}
                  </div>
                }

                <div class="table-responsive">
                  <table class="table table-sm table-centered mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>{{ "shared.contactUploadCsv.fileColumn" | translate }}</th>
                        <th>{{ "shared.contactUploadCsv.preview" | translate }}</th>
                        <th>{{ "shared.contactUploadCsv.targetField" | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (column of audienceFileColumns; track column.csvColumn) {
                        <tr>
                          <td class="fw-semibold">{{ column.csvColumn }}</td>
                          <td class="text-muted">{{ column.sample || "—" }}</td>
                          <td>
                            <mat-select
                              class="form-control"
                              [value]="audienceFieldOf(column.csvColumn)"
                (selectionChange)="
                  onAudienceMappingChange(column.csvColumn, $event.value)
                "
                              >
                              <mat-option value="phone">{{
                                "campaign.campaignForm.audienceFileColumnPhone" | translate
                              }}</mat-option>
                              <mat-option value="name">{{
                                "campaign.campaignForm.audienceFileColumnName" | translate
                              }}</mat-option>
                              <mat-option value="email">{{
                                "campaign.campaignForm.audienceFileColumnEmail" | translate
                              }}</mat-option>
                              <mat-option value="ignore">{{
                                "shared.contactUploadCsv.fieldIgnore" | translate
                              }}</mat-option>
                            </mat-select>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </ng-template>

              <ng-template #audienceFilePreview>
                <div class="custom-switch mb-3">
                  <input
                    type="checkbox"
                    id="audienceApplyCountryPrefix"
                    data-switch="success"
                    [checked]="audienceApplyCountryPrefix"
                    (change)="onToggleAudienceCountryPrefix()"
                    />
                  <label for="audienceApplyCountryPrefix">
                    <span class="text-muted">{{
                      "campaign.campaignForm.audienceFileApplyCountryPrefix" | translate
                    }}</span>
                  </label>
                </div>

                @if (audienceFileTotalRows > audienceFileValidRows) {
                  <div class="mb-3">
                    <button
                      type="button"
                      class="btn btn-sm btn-soft-secondary"
                      (click)="toggleAudienceErrorsOnly()"
                      >
                      {{
                      (audienceShowOnlyErrors
                      ? "campaign.campaignForm.audienceFileShowAll"
                      : "campaign.campaignForm.audienceFileShowErrors"
                      ) | translate
                      }}
                    </button>
                  </div>
                }

                <div class="table-responsive">
                  <table class="table table-sm table-centered table-hover mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>
                          {{ "campaign.campaignForm.audienceFileColumnPhone" | translate }}
                        </th>
                        <th>
                          {{ "campaign.campaignForm.audienceFileColumnName" | translate }}
                        </th>
                        <th>
                          {{ "campaign.campaignForm.audienceFileColumnEmail" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of audienceFilePreviewRows; track row.index) {
                        <tr [class.text-danger]="row.hasError">
                          <td>
                            {{ row.phone }}
                            @if (row.hasError) {
                              <i
                                class="mdi mdi-alert-circle-outline ms-1"
                                [title]="audienceRowErrorKey(row) | translate"
                              ></i>
                            }
                          </td>
                          <td>
                            @if (row.name) {
                              {{ row.name }}
                            } @else {
                              <span class="text-muted">—</span>
                            }
                          </td>
                          <td>
                            @if (row.email) {
                              {{ row.email }}
                            } @else {
                              <span class="text-muted">—</span>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>

                @if (audienceFileTotalRows > AUDIENCE_PREVIEW_ROWS) {
                  <p class="campaign-field-hint mt-2 mb-0">
                    {{
                    "campaign.campaignForm.audienceFilePreviewHint"
                    | translate
                    : {
                    shown: AUDIENCE_PREVIEW_ROWS,
                    total: audienceFileTotalRows,
                  }
                  }}
                </p>
              }

              @if (audienceFileValidRows < audienceFileTotalRows) {
                <div
                  class="alert mt-3 mb-0"
                  [class.alert-danger]="audienceFileValidRows === 0"
                  [class.alert-warning]="audienceFileValidRows > 0"
                  role="alert"
                  >
                  @if (audienceFileMissingCountryCodeRows > 0) {
                    <p class="mb-1">
                      <i class="mdi mdi-alert-circle-outline me-1"></i>
                      {{
                      "campaign.campaignForm.audienceFileMissingCountryCodeAlert"
                      | translate
                      : {
                      count: audienceFileMissingCountryCodeRows,
                      total: audienceFileTotalRows,
                    }
                    }}
                  </p>
                }
                @if (audienceFileInvalidPhoneRows > 0) {
                  <p class="mb-0">
                    <i class="mdi mdi-alert-circle-outline me-1"></i>
                    {{
                    "campaign.campaignForm.audienceFileInvalidPhoneAlert"
                    | translate
                    : {
                    count: audienceFileInvalidPhoneRows,
                    total: audienceFileTotalRows,
                  }
                  }}
                </p>
              }
            </div>
          }
        </ng-template>

        <ng-template #summaryRail>
          <div class="campaign-collapse">
            <button
              type="button"
              class="campaign-collapse-head"
              [class.is-open]="summaryOpen"
              [attr.aria-expanded]="summaryOpen"
              (click)="summaryOpen = !summaryOpen"
              >
              <b>{{ "campaign.campaignForm.summaryTitle" | translate }}</b>
              <span class="campaign-collapse-tail">
                <!-- Balance badge only when the channel consumes from a wallet: RCS, or
                a credit-line Cloud API channel. On an ordinary Cloud API channel
                and on Z-API there is no balance to run short of, and "balance ok"
                there would vouch for a wallet the dispatch never touches. -->
                @if (summaryShowsBalance) {
                  <span
                    class="campaign-badge"
                    [ngClass]="summaryHasBalance ? 'is-ok' : 'is-err'"
                    >
                    {{
                    (summaryHasBalance
                    ? "campaign.campaignForm.balanceOk"
                    : "campaign.campaignForm.balanceShort"
                    ) | translate
                    }}
                  </span>
                }
                <i
                  class="mdi mdi-chevron-down campaign-collapse-caret"
                  aria-hidden="true"
                ></i>
              </span>
            </button>

            @if (summaryOpen) {
              <div class="campaign-collapse-body">
                <div class="campaign-summary-group">
                  <div class="campaign-sum-line">
                    <span class="k">{{
                      "campaign.campaignForm.channelLabel" | translate
                    }}</span>
                    <span class="v">{{ selectedChannel?.name || "—" }}</span>
                  </div>
                  <div class="campaign-sum-line">
                    <span class="k">{{
                      "campaign.campaignForm.originLabel" | translate
                    }}</span>
                    <span class="v">{{ summaryOriginText || "—" }}</span>
                  </div>
                  <div class="campaign-sum-line">
                    <span class="k">{{
                      "campaign.campaignForm.baseSelected" | translate
                    }}</span>
                    <span class="v">
                      @if (audienceSummaryLoading) {
                        <span
                          class="spinner-border spinner-border-sm text-muted"
                          role="status"
                  [attr.aria-label]="
                    'campaign.campaignForm.summaryLoading' | translate
                  "
                        ></span>
                      } @else if (audienceSummaryFailed || !audienceSummary) {
                        —
                      } @else {
                        {{ audienceSummary.selectedBase | number: "1.0-0" }}
                      }
                    </span>
                  </div>
                  <div class="campaign-sum-line">
                    <span class="k">{{
                      "campaign.campaignForm.deductionExcluded" | translate
                    }}</span>
                    <span class="v">
                      @if (audienceSummaryLoading) {
                        <span
                          class="spinner-border spinner-border-sm text-muted"
                          role="status"
                        ></span>
                      } @else if (audienceSummaryFailed || !audienceSummary) {
                        —
                      } @else {
                        {{ audienceSummary.excluded | number: "1.0-0" }}
                      }
                    </span>
                  </div>
                  <div class="campaign-sum-line">
                    <span class="k">{{
                      "campaign.campaignForm.deductionDuplicated" | translate
                    }}</span>
                    <span class="v">
                      @if (audienceSummaryLoading) {
                        <span
                          class="spinner-border spinner-border-sm text-muted"
                          role="status"
                        ></span>
                      } @else if (audienceSummaryFailed || !audienceSummary) {
                        —
                      } @else {
                        {{ audienceSummary.duplicated | number: "1.0-0" }}
                      }
                    </span>
                  </div>
                </div>

                @if (audienceSummaryFailed) {
                  <div class="alert alert-warning py-1 px-2 mb-2 small">
                    {{ "campaign.campaignForm.summaryUnavailable" | translate }}
                  </div>
                } @else if (!audienceSummary && !audienceSummaryLoading) {
                  <div class="text-muted small mb-2">
                    {{ "campaign.campaignForm.summaryEmpty" | translate }}
                  </div>
                } @else if (audienceReachesNobody) {
                  <div class="alert alert-warning py-1 px-2 mb-2 small">
                    {{ "campaign.campaignForm.summaryReachesNobody" | translate }}
                  </div>
                }

                <div class="campaign-summary-group">
                  <div class="campaign-sum-line campaign-sum-strong">
                    <span class="k">{{
                      "campaign.campaignForm.totalToSend" | translate
                    }}</span>
                    <span class="v">
                      @if (audienceSummaryLoading) {
                        <span
                          class="spinner-border spinner-border-sm text-muted"
                          role="status"
                        ></span>
                      } @else if (audienceSummaryFailed || !audienceSummary) {
                        —
                      } @else {
                        {{ audienceSummary.totalToSend | number: "1.0-0" }}
                      }
                    </span>
                  </div>
                  @if (
                    summaryShowsPricePerMessage ||
                    summaryUnpriced ||
                    summaryAwaitingTemplate ||
                    summaryPriceLoading
                    ) {
                    <div class="campaign-sum-line">
                      <span class="k">
                        {{ "campaign.campaignForm.pricePerMessage" | translate }}
                        @if (summarySessionPrice !== null) {
                          <i
                            class="mdi mdi-information-outline ms-1 text-muted"
                    [matTooltip]="
                      'campaign.campaignForm.pricePerMessageSessionHint'
                        | translate
                          : {
                              price:
                                summarySessionPrice
                                | currency
                                  : summaryPriceCurrency
                                  : 'symbol'
                                  : summaryPriceDigits,
                            }
                    "
                        ></i>
                      }
                    </span>
                    <span class="v">
                      @if (summaryPriceLoading) {
                        <span
                          class="spinner-border spinner-border-sm text-muted"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      } @else if (summaryAwaitingTemplate) {
                        <span class="text-muted">{{
                          "campaign.campaignForm.priceAwaitingTemplate" | translate
                        }}</span>
                      } @else if (summaryUnpriced) {
                        <span class="text-muted">{{
                          summaryUnpricedLabel | translate
                        }}</span>
                      } @else {
                        {{
                        summaryPricePerMessage
                        | currency: summaryPriceCurrency : "symbol" : summaryPriceDigits
                        }}
                      }
                    </span>
                  </div>
                }
              </div>

              <div class="campaign-summary-group">
                <div class="campaign-sum-line campaign-sum-total">
                  <span class="k">{{
                    "campaign.campaignForm.estimatedCost" | translate
                  }}</span>
                  <span class="v">
                    @if (
                      summaryAwaitingTemplate ||
                      summaryUnpriced ||
                      summaryPriceLoading
                      ) {
                      <span class="text-muted">—</span>
                    } @else {
                      {{
                      summaryEstimatedCost
                      | currency: summaryPriceCurrency : "symbol" : "1.2-2"
                      }}
                    }
                    <!-- Balance only where a wallet bills the dispatch: RCS, and Cloud
                    API on a credit-line channel — both quoted in BRL. An ordinary
                    Cloud API channel never shows one, which is also what keeps a
                    USD price from ever being subtracted from a BRL balance. -->
                    @if (summaryShowsBalance) {
                      <small>
                        {{ "campaign.campaignForm.balanceAfter" | translate }}
                        {{
                        summaryBalanceAfter | currency: "BRL" : "symbol" : "1.2-2"
                        }}
                      </small>
                    }
                  </span>
                </div>
              </div>
              @if (isSelectedChannelCloudAPI()) {
                <div class="campaign-summary-group">
                  <div class="campaign-panel-head">
                    <span class="campaign-panel-icon" aria-hidden="true"
                      ><i class="mdi mdi-whatsapp"></i
                    ></span>
                    <div>
                      <b>{{
                        "campaign.campaignForm.whatsappOfficialApi" | translate
                      }}</b>
                      <p>
                        {{
                        "campaign.campaignForm.whatsappOfficialApiDesc" | translate
                        }}
                      </p>
                    </div>
                  </div>
                  <ul class="campaign-feature-list">
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureApprovedTemplates" | translate
                      }}</span>
                    </li>
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureHighDeliverability" | translate
                      }}</span>
                    </li>
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureOfficialVerification"
                        | translate
                      }}</span>
                    </li>
                  </ul>
                </div>
              } @else if (isSelectedChannelZAPI()) {
                <div class="campaign-summary-group">
                  <div class="campaign-panel-head">
                    <span class="campaign-panel-icon" aria-hidden="true"
                      ><i class="mdi mdi-whatsapp"></i
                    ></span>
                    <div>
                      <b>WhatsApp Business</b>
                      <p>
                        {{ "campaign.campaignForm.whatsappBusinessDesc" | translate }}
                      </p>
                    </div>
                  </div>
                  <ul class="campaign-feature-list">
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureFreeText" | translate
                      }}</span>
                    </li>
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureImageSending" | translate
                      }}</span>
                    </li>
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureFullFlexibility" | translate
                      }}</span>
                    </li>
                  </ul>
                </div>
              } @else if (isSelectedChannelRcsAPI()) {
                <div class="campaign-summary-group">
                  <div class="campaign-panel-head">
                    <span class="campaign-panel-icon" aria-hidden="true"
                      ><i class="mdi mdi-card-text-outline"></i
                    ></span>
                    <div>
                      <b>RCS</b>
                      <p>Rich Communication Services</p>
                    </div>
                  </div>
                  <ul class="campaign-feature-list">
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureRichMedia" | translate
                      }}</span>
                    </li>
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureInteractiveButtons" | translate
                      }}</span>
                    </li>
                    <li>
                      <i class="mdi mdi-check" aria-hidden="true"></i
                        ><span>{{
                        "campaign.campaignForm.featureReadReceipt" | translate
                      }}</span>
                    </li>
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </ng-template>

      <ng-template #stepperNav>
        <nav
          class="campaign-stepper ms-1rem p-1"
          [attr.aria-label]="'campaign.campaignForm.stepperLabel' | translate"
          >
          @for (step of steps; track step.title; let i = $index) {
            <button
              type="button"
              class="campaign-step"
              [class.is-done]="i + 1 < currentStep"
              [class.is-current]="i + 1 === currentStep"
              [disabled]="!canGoToStep(i)"
              [attr.aria-current]="i + 1 === currentStep ? 'step' : null"
              [matTooltip]="step.subtitle | translate"
              (click)="goToStep(i)"
              >
              <span class="campaign-step-dot" aria-hidden="true">
                @if (i + 1 < currentStep) {
                  <i class="mdi mdi-check"></i>
                } @else {
                  {{ i + 1 }}
                }
              </span>
              <span class="campaign-step-bar" aria-hidden="true"></span>
              <span class="campaign-step-label">
                <span class="campaign-step-n">
                  {{ "campaign.campaignForm.stepNumber" | translate: { n: i + 1 } }}
                </span>
                <strong class="campaign-step-t">{{ step.title | translate }}</strong>
              </span>
            </button>
          }
        </nav>
      </ng-template>

      <ng-template #previewRail>
        <div class="campaign-collapse">
          <button
            type="button"
            class="campaign-collapse-head"
            [class.is-open]="previewOpen"
            [attr.aria-expanded]="previewOpen"
            (click)="previewOpen = !previewOpen"
            >
            <b>{{ "campaign.campaignForm.previewTitle" | translate }}</b>
            <span class="campaign-collapse-tail">
              <i
                class="mdi mdi-chevron-down campaign-collapse-caret"
                aria-hidden="true"
              ></i>
            </span>
          </button>

          @if (previewOpen) {
            <div
              class="campaign-collapse-body is-preview custom-scroll-bar d-flex justify-content-center"
              >
              @if (selectedChannel?.type === "Z_API") {
                @if (
                  formGroup.get("zapiDataGroup.messageType")?.value === "buttons"
                  ) {
                  <chat-wa-preview
                    [title]="$safeNavigationMigration(formGroup.get('zapiDataGroup.buttonsTitle')?.value)"
                    [message]="$safeNavigationMigration(formGroup.get('zapiDataGroup.buttonsMessage')?.value)"
                    [footer]="$safeNavigationMigration(formGroup.get('zapiDataGroup.buttonsFooter')?.value)"
                    [buttons]="$safeNavigationMigration($any(getZAPIFormGroup.get('buttonActions'))?.value)"
                    [templateType]="'button'"
                    [showChatFrame]="false"
                    />
                } @else {
                  <campaign-evo-template
                    [zapiData]="getZAPIFormGroup.value"
                  ></campaign-evo-template>
                }
              } @else if (selectedChannel?.type === "RCS_API") {
                <rcs-message-preview [rcsData]="getRCSFormGroup.value" />
              } @else {
                <campaign-cloud-api-template
                  [cloudAPIData]="cloudAPIData"
                ></campaign-cloud-api-template>
              }
            </div>
          }
        </div>
      </ng-template>

      <ng-template #rcsBillingRail>
        @if (isSelectedChannelRcsAPI()) {
          <campaign-rcs-billing></campaign-rcs-billing>
        }
      </ng-template>
